import { CodeEditorView } from './CodeEditorView';

export default CodeEditorView;